import type { ReactNode } from 'react';

/**
 * Cabeçalho único das páginas internas (auditoria A6 e M9): um h1 por página, descrição embaixo e as
 * ações à direita, sempre na mesma posição. No celular as ações quebram linha (D23a).
 */
interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  icon?: ReactNode;
}

export function PageHeader({ title, description, actions, icon }: PageHeaderProps) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 'var(--space-4)', marginBottom: 'var(--space-8)' }}>
      <div style={{ minWidth: 0, flex: '1 1 280px' }}>
        <h1 style={{ fontSize: 'var(--text-2xl)', fontWeight: 'var(--font-semibold)', color: 'var(--color-text-primary)', lineHeight: 'var(--leading-tight)', display: 'flex', alignItems: 'center', gap: 'var(--space-2)', overflowWrap: 'anywhere' }}>
          {icon}
          {title}
        </h1>
        {description && <p style={{ color: 'var(--color-text-secondary)', marginTop: 'var(--space-2)' }}>{description}</p>}
      </div>
      {actions && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-3)', minWidth: 0, alignItems: 'center' }}>
          {actions}
        </div>
      )}
    </div>
  );
}
